import React, { PureComponent, Component} from "react";
import {getConfig} from './config.js';

/*
export function isMobileDevice() {
  // For now, let's use the screen dimension - as Bootstrap does
  const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
  //log('Viewport width: ', vw, vw < 767);
  return (vw < 767); // iPad in portrait mode

    // User agent base navigation
	if( navigator.userAgent.match(/Android/i)
		|| navigator.userAgent.match(/webOS/i)
 		|| navigator.userAgent.match(/iPhone/i)
 		|| navigator.userAgent.match(/iPad/i)
 		|| navigator.userAgent.match(/iPod/i)
 		|| navigator.userAgent.match(/BlackBerry/i)
 		|| navigator.userAgent.match(/Windows Phone/i)
 	){
    	return true;
  	} else {
    	return false;
	}
}

export function isTabletDevice() {
    // For now, let's use the screen dimension - as Bootstrap does
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    //log('Viewport width: ', vw);
    return (vw > 767 && vw <= 1023); // iPad in portrait mode

  if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    || (window.innerWidth <= 1023 && window.innerWidth > 767)
  ){
    return true;
  } else {
    return false;
  }
}
*/

export function callAPI(url) {

    //var _h = new Headers();
    //var _f = new FormData();
    //Object.keys(params).forEach((key) => _f.append(key, params[key]));
    return window.fetch(url, {
            credentials: 'include',
            //headers: _h,
            //mode: 'cors',
            method: 'GET',
            //body: _f,
        })
        .then(
            function(response) {
                //-console.log(response);
                if (response.status === 401) {
                    throw '';
                }
                if (response.status === 402) {
                    throw '';
                }
                if (response.status !== 200) {
                    throw '';
                }
                return response.json();
            }
        );
}

/*
export function showError(msg) {
    window.alert('An error has ocurred. Please try again');
    log('error');
}*/


export function infiniteTitle(title, _that) {
  let titles = []

   for (let i = 0; i < 40; i++) {
     titles.push(<span key={i}>{title}</span>);
   }
   let titleWidth = title.length * 40 * 70;
   _that.setState({titles: titles, titleWidth: titleWidth});
  let genI = 40;
  setInterval(function(genI) {
     titles.push(<span key={genI}>{title}</span>)
     genI++;

    titleWidth += title.length * 70;
     _that.setState({titles: titles, titleWidth: titleWidth});

   }, 10000);
   return (
     titles
   )
}


export function cleanPath(url) {

  let base = getConfig().base;
  let cleanpath = url.replace(base, '');
  return cleanpath;
}

export function getScrollWidth(elementRef) {

  const scrollWidth = document.body.offsetWidth - elementRef.clientWidth;
  return scrollWidth;
}

export function darkMode(status) {
  if (status) {
    document.body.classList.add('body--darktheme');
    document.body.classList.remove('body--cinema');
  } else {
    document.body.classList.remove('body--darktheme');
    document.body.classList.remove('body--cinema');
  }
}
